var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiummatches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3412)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6016 14H33.3224C31.2641 14 29.6016 15.6625 29.6016 17.7208V43.0542C29.6016 45.1125 31.2641 46.775 33.3224 46.775H48.6016C50.6599 46.775 52.3224 45.1125 52.3224 43.0542V17.7208C52.3224 15.6625 50.6599 14 48.6016 14ZM40.6357 26.5C40.6357 26.5 40.1357 26.5 34.1141 28.1708C37.8349 27.1384 39.5774 28.1708 41.6357 28.1708C42.9024 28.1708 45.5024 28.9708 46.1357 30C46.7691 28.9708 46.6357 28 43.6357 28C40.6357 30.5 31.6357 31.5 47.3566 31.7208C44.1357 29 40.6357 26.5 40.6357 26.5Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.72 28.1412C47.5182 28.0045 47.2801 27.9314 47.0364 27.9314C46.7927 27.9314 46.5546 28.0045 46.3529 28.1412L44.2279 29.4587C44.2067 29.4683 44.1838 29.4733 44.1606 29.4733C44.1374 29.4733 44.1144 29.4683 44.0933 29.4587C44.046 29.446 44.0055 29.4155 43.98 29.3737L41.7133 25.2937C41.6031 25.1104 41.4473 24.9587 41.2612 24.8533C41.075 24.748 40.8647 24.6926 40.6508 24.6926C40.4369 24.6926 40.2266 24.748 40.0404 24.8533C39.8542 24.9587 39.6985 25.1104 39.5883 25.2937L37.2366 29.3667C37.2111 29.4085 37.1706 29.4389 37.1233 29.4517C37.1021 29.4612 37.0792 29.4662 37.056 29.4662C37.0328 29.4662 37.0098 29.4612 36.9887 29.4517L34.8991 28.1129C34.6968 27.9849 34.4613 27.9193 34.2219 27.9243C33.9826 27.9294 33.75 28.0048 33.5533 28.1412C33.3514 28.2792 33.1951 28.4741 33.1043 28.7011C33.0134 28.9282 32.9922 29.1771 33.0433 29.4162L34.2333 35.005C34.2917 35.2831 34.444 35.5326 34.6645 35.7119C34.885 35.8911 35.1604 35.9892 35.4445 35.9896H45.85C46.1341 35.9892 46.4095 35.8911 46.63 35.7119C46.8505 35.5326 47.0027 35.2831 47.0612 35.005L48.2512 29.4162C48.3001 29.175 48.2757 28.9246 48.181 28.6973C48.0863 28.4701 47.9257 28.2764 47.72 28.1412Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1863 48.3083C30.2572 48.3083 27.8822 45.9333 27.8822 43.0042V37.8583C27.9613 35.45 26.8822 39.1639 27.8822 38.6639C27.8822 38.6639 28 37.45 27.9613 34.95C27.9613 32.7917 28 33.45 27.8822 28.675V17.6708C27.8822 17.275 27.9613 16.9583 27.9613 16.5625L17.7488 19.3333C15.7697 19.8875 14.5822 21.9458 15.1363 23.925L21.7072 48.3875C22.2613 50.3667 24.3197 51.5542 26.2988 51L36.2738 48.3083H33.1863Z",
    fill: "#E60000",
    fillOpacity: 0.81
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3412",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiummatches);
export default __webpack_public_path__ + "static/media/PREMIUMMATCHES.c43416755b6a3a94f3adf9522c00d872.svg";
export { ForwardRef as ReactComponent };